module.exports = __webpack_public_path__ + "static/media/iconExclamationMarkRed.af236f45.svg";